import { whyChooseUsData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function WhyChooseUsSection() {
  return (
    <section id="about" className="py-20 md:py-28 bg-background-100 relative overflow-hidden">
      {/* Decorative pattern */}
      <div className="absolute inset-0 dot-pattern opacity-40" />

      <div className="container-astro relative z-10">
        <AnimatedSection>
          <div className="text-center mb-14 md:mb-18">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mb-5 font-heading tracking-tight">
              {whyChooseUsData.heading}
            </h2>
            <div className="w-16 h-1 bg-accent-500 rounded-full mx-auto" />
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {whyChooseUsData.items.map((item, i) => (
            <AnimatedSection key={item.title} delay={i * 100}>
              <div className="group p-7 md:p-8 rounded-2xl bg-background-50 border border-background-200/60 hover:border-accent-300/30 hover:shadow-lg hover:shadow-accent-500/5 transition-all duration-400 card-lift h-full">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2.5 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}